const solicitudDeAlta = { "tipoSolicitud": "ALTA_CONSULTORIO", "descripcionSolicitud": "Alta de consultorio" };
const solicitudDeModificacion = { "tipoSolicitud": "MODIFICACION_CONSULTORIO", "descripcionSolicitud": "Modificacion de consultorio" };
const solicitudDeBaja = { "tipoSolicitud": "BAJA_CONSULTORIO", "descripcionSolicitud": "Baja de consultorio" };

export { solicitudDeAlta, solicitudDeModificacion, solicitudDeBaja };